<script setup>
const props = defineProps({
  modelValue: { type: Number, default: 0 },
  min: { type: Number, default: 0 },
  max: { type: Number, default: 100 },
  step: { type: Number, default: 1 },
  unit: { type: String, default: '' },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);
const set = raw =>
  emit(
    'update:modelValue',
    Math.min(props.max, Math.max(props.min, Number(raw) || props.min))
  );
</script>

<template>
  <label class="flex flex-col gap-1.5">
    <span class="text-xs font-medium text-n-slate-11">{{ label }}</span>
    <div class="flex items-center gap-2">
      <input
        type="range"
        class="flex-1 accent-n-brand"
        :min="min"
        :max="max"
        :step="step"
        :value="modelValue"
        @input="set($event.target.value)"
      />
      <input
        type="number"
        class="w-14 rounded-md border border-n-weak bg-transparent px-1.5 py-0.5 text-xs"
        :min="min"
        :max="max"
        :step="step"
        :value="modelValue"
        @input="set($event.target.value)"
      />
      <span v-if="unit" class="text-xs text-n-slate-10">{{ unit }}</span>
    </div>
  </label>
</template>
